import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=5ce1fd60&"
import script from "@/scripts/Exercise/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Exercise/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports